import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z
  .object({
    identifier: z.string().min(1, t('pages.application_predictions.components.predictions_create_modal.schema.required')),
    title: z.string().min(1, t('pages.application_predictions.components.predictions_create_modal.schema.required')),
    description: z.string().min(1, t('pages.application_predictions.components.predictions_create_modal.schema.required')),
    status: z.string().min(1, t('pages.application_predictions.components.predictions_create_modal.schema.required')),
    option_a_image: z.any().refine(image => {
      return !!image;
    }, t('pages.application_predictions.components.predictions_create_modal.schema.required_image')),
    option_a_name: z.string().min(1, t('pages.application_predictions.components.predictions_create_modal.schema.required')),
    option_b_image: z.any().refine(image => {
      return !!image;
    }, t('pages.application_predictions.components.predictions_create_modal.schema.required_image')),
    option_b_name: z.string().min(1, t('pages.application_predictions.components.predictions_create_modal.schema.required')),
    has_closing_date: z.boolean(),
    closing_date: z.string().optional(),
    disable_comments: z.boolean(),
    enable_home: z.boolean(),
    team_uuid: z.string().optional(),
  })
  .refine(
    values => {
      const needDate = values.has_closing_date && !values.closing_date;

      return !needDate;
    },
    {
      message: t('pages.application_predictions.components.predictions_create_modal.schema.required'),
      path: ['closing_date'],
    },
  );

export type ModalFormData = z.infer<typeof modalFormSchema>;
